import type { DraggableEvent } from "react-draggable"

export type RefineDraggableEvent = (
  e: DraggableEvent,
) => { type: `mouse`; event: MouseEvent } | { type: `touch`; event: TouchEvent }

export const refineDraggableEvent: RefineDraggableEvent = (e) =>
  e.type === `touchmove`
    ? { type: `touch`, event: e as TouchEvent }
    : { type: `mouse`, event: e as MouseEvent }
